module.exports = __webpack_public_path__ + "static/media/cloud-sleet.850bec26.svg";